import tokenFromLS from "../tokenFromLS";
import {state as globalState} from "../../state";
import { handleSessionEnded } from "../impersonation";

class CBApi {
  static API_URL = process.env.REACT_APP_API_URI;

  static fetch(path, method = 'GET', params) {
    // Remove leading slash from path if present
    if (path.startsWith('/')) {
      path = path.substring(1);
    }
    const resource = `${CBApi.API_URL}/${path}`;
    let fetchOptions = {
      method: method,
      headers: {
        Authorization: `Bearer ${tokenFromLS(globalState.token)}`,
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
      },
    };

    if (method !== 'GET') {
      // Post Params:
      fetchOptions.body = JSON.stringify(params);
    }

    return fetch(resource, fetchOptions)
      .then(async response => {
        // Check for 401 Unauthorized status
        if (response.status === 401) {
          // An expired impersonation goes back to the admin's own login
          if (handleSessionEnded()) {
            return Promise.reject(new Error('Impersonation ended - returning to admin account'));
          }
          // Clear token from localStorage
          localStorage.removeItem('token');
          // Redirect to login page
          window.location.href = '/login';
          return Promise.reject(new Error('Unauthorized - redirecting to login'));
        }

        const body = await response.json().catch(() => null);

        // Check if response is ok
        if (!response.ok) {
          const msg = body?.message || body?.error || `HTTP error! status: ${response.status}`;
          throw new Error(msg);
        }

        return body;
      })
      .catch(error => {
        console.error('Error:', error);
        throw error;
      });
  }
}

export default CBApi;